export default __webpack_public_path__ + "0a3349a4be436a4346c912b9f34c16e5.jpg";